module.exports = __webpack_public_path__ + "shy.1d290879.png";